<script setup lang="ts">
import { Bell } from '@/shared/icons'
import { Alert } from '@/shared/ui/Alert'
import { Button } from '@/shared/ui/Button'
import { IconTile } from '@/shared/ui/IconTile'
import { Inline } from '@/shared/ui/Inline'
import { Loading } from '@/shared/ui/Loading'
import { PageHeading } from '@/shared/ui/PageHeading'
import { Stack } from '@/shared/ui/Stack'

import { useUnsubscribePage } from '../model/useUnsubscribePage'

const {
  isLoading,
  error,
  alreadyUnsubscribed,
  justUnsubscribed,
  canUnsubscribe,
  isSubmitting,
  confirm,
  goHome
} = useUnsubscribePage()
</script>

<template>
  <Stack :gap="28">
    <IconTile :icon="Bell" />

    <Loading v-if="isLoading" :loading="isLoading" />

    <Alert v-else-if="error" type="error" :title="error" />

    <template v-else>
      <PageHeading>
        {{ justUnsubscribed ? "You're unsubscribed" : 'Unsubscribe' }}
        <template v-if="alreadyUnsubscribed" #lede>
          You won't receive our regular notifications any more.
        </template>
        <template v-else #lede>
          Are you sure you want to unsubscribe?
        </template>
      </PageHeading>

      <Inline v-if="canUnsubscribe" :gap="8" justify="between" block>
        <Button type="primary" :loading="isSubmitting" @click="confirm">
          Unsubscribe
        </Button>
        <Button @click="goHome">Back</Button>
      </Inline>
    </template>
  </Stack>
</template>
